/* ==========================================================================
   Umya · Grabado del mensaje dentro de la ficha
   21-ago-2026

   Tres cosas, y solo tres:

   1. El campo del mensaje solo acepta lo que la maquina sabe grabar
      (mayusculas, numeros y . - |). Escribir en minuscula y descubrirlo al
      recibir la pieza no es una opcion.

   2. El tramo de precio lo elige el propio texto. Los punos se cobran por
      longitud (hasta 25, 26-30, 31-35, 36-40) y hasta hoy el cliente tenia que
      contar sus letras a mano y acertar la variante. Aqui se cuenta solo.

   3. Al comprar van DOS lineas al carrito en la misma peticion: la joya y el
      grabado. Es lo que hace que esto sea una opcion de la ficha y no dos
      compras separadas. Shopify las mete o no mete ninguna, asi que nunca se
      queda un grabado suelto sin su joya.

   Si el guion no carga, la casilla no aparece marcada y la ficha compra la
   joya como siempre: no se rompe nada, solo no hay grabado.
   ========================================================================== */

(() => {
  const bloques = document.querySelectorAll('[data-umya-grabado]');
  if (!bloques.length) return;

  /* Ir al carrito sin salirse de la vista previa. Medido el 21-ago: un
     window.location a /cart desde la previa acaba en umya.be con el tema
     viejo Y con el carrito vacio, porque al cambiar de dominio se queda
     atras la galleta que guarda lo que llevabas. El _fd=0 es lo que frena
     esa redireccion (mismo truco que umya-vistaprevia.js). */
  const irAlCarrito = () => {
    const destino = new URL(window.routes.cart_url, window.location.origin);
    const t = window.Shopify && window.Shopify.theme;
    if (t && t.role && t.role !== 'main') destino.searchParams.set('_fd', '0');
    window.location = destino.toString();
  };

  bloques.forEach((bloque) => {
    let tramos = [];
    try {
      tramos = JSON.parse(bloque.dataset.tramos || '[]');
    } catch (e) {
      /* Sin tramos no hay nada que ofrecer: mejor esconder la casilla que
         enseñar una opción que al pulsarla no sabría qué añadir. */
      bloque.hidden = true;
      return;
    }
    tramos = tramos.filter((t) => t && t.id && t.disponible !== false).sort((a, b) => a.max - b.max);
    if (!tramos.length) {
      bloque.hidden = true;
      return;
    }

    const casilla = bloque.querySelector('[data-umya-grabado-check]');
    const panel = bloque.querySelector('[data-umya-grabado-panel]');
    const campo = bloque.querySelector('[data-umya-grabado-texto]');
    const cuenta = bloque.querySelector('[data-umya-grabado-cuenta]');
    const precio = bloque.querySelector('[data-umya-grabado-precio]');
    const total = bloque.querySelector('[data-umya-grabado-total]');
    if (!casilla || !campo) return;

    const tope = tramos[tramos.length - 1].max;
    campo.maxLength = tope;

    /* El ajuste del tema guarda los caracteres válidos como un rango de los
       que se usan en las búsquedas ("A-Z0-9 .|-"). Ojo con el guion: escrito
       en medio ("A-Z0-9 .-|") no significa "el guion", significa "todo lo que
       hay entre el punto y la barra vertical", que son ochenta caracteres e
       incluye la arroba. Medido el 21-ago: escribiendo "SIEMPRE 21/06 @" el
       campo se lo tragaba entero. Por eso el guion va al final del ajuste, y
       por eso debajo hay una prueba de humo que lo comprueba. */
    const permitidos = bloque.dataset.permitidos || 'A-Z0-9 .|-';
    let filtro = null;
    try {
      filtro = new RegExp('[^' + permitidos + ']', 'g');
      /* Prueba de humo: si el filtro deja pasar una arroba, está mal escrito
         y se cae al de fábrica en vez de dejar entrar cualquier cosa. */
      if ('@'.replace(filtro, '') === '@') filtro = /[^A-Z0-9 .|-]/g;
    } catch (e) {
      filtro = /[^A-Z0-9 .|-]/g;
    }

    const tramoDe = (largo) => tramos.find((t) => largo <= t.max) || tramos[tramos.length - 1];

    /* El precio de la joya no es fijo en Choose your stone: cambia con la
       piedra. Se lee de la pantalla en el momento de pintar el total, no al
       cargar. */
    const precioJoya = () => {
      const caja = bloque.closest('.product__info-container, .product') || document;
      const nodo = caja.querySelector('.price__regular .price-item--regular, .price-item--sale, .price-item--regular');
      if (!nodo) return null;
      const limpio = nodo.textContent.replace(/[^\d,.]/g, '').replace(/\.(?=\d{3}\b)/g, '');
      const valor = parseFloat(limpio.replace(',', '.'));
      return isNaN(valor) ? null : Math.round(valor * 100);
    };

    /* Se toma prestada la forma de escribir el precio del propio tramo
       ("€35,00" o "35,00 €" según la tienda) para no inventar un formato
       distinto tres líneas más abajo. */
    const comoDinero = (centimos, molde) => {
      const num = (centimos / 100).toFixed(2).replace('.', ',');
      return molde.replace(/[\d.,]+/, num);
    };

    const repintar = () => {
      const largo = campo.value.length;
      const tramo = tramoDe(largo);
      if (cuenta) cuenta.textContent = largo + ' / ' + tope;
      if (precio) precio.textContent = tramo.etiqueta;
      campo.dataset.varianteGrabado = tramo.id;

      if (total) {
        const joya = precioJoya();
        if (joya && casilla.checked) {
          total.textContent =
            (bloque.dataset.textoTotal || 'Piece + engraving:') +
            ' ' +
            comoDinero(joya + tramo.precio, tramo.etiqueta);
          total.hidden = false;
        } else {
          total.hidden = true;
        }
      }
    };

    casilla.addEventListener('change', () => {
      if (panel) panel.hidden = !casilla.checked;
      campo.disabled = !casilla.checked;
      if (casilla.checked) campo.focus();
      else campo.value = '';
      repintar();
    });

    campo.addEventListener('input', () => {
      const antes = campo.value;
      /* El tope lo pone el navegador con maxlength, pero solo cuando se
         escribe a mano. Se vuelve a cortar aquí para que un texto que llegue
         por otro camino (autocompletar, un pegado raro) no acabe pidiendo un
         grabado más largo del que cabe en la pieza. */
      const despues = antes.toUpperCase().replace(filtro, '').slice(0, tope);
      if (antes !== despues) {
        const pos = campo.selectionStart - (antes.length - despues.length);
        campo.value = despues;
        try {
          campo.setSelectionRange(pos, pos);
        } catch (e) {
          /* algunos navegadores no dejan mover el cursor en campos ocultos */
        }
      }
      repintar();
    });

    /* ---------- las dos líneas al carrito ---------- */

    const formulario = document.getElementById(campo.getAttribute('form'));
    if (!formulario) return;

    const activo = () => casilla.checked && campo.value.trim().length > 0;

    /* En fase de captura: este oyente corre ANTES que el de Dawn, que es lo
       que permite quedarse con el envío y hacer la petición doble. Sin
       grabado marcado no se toca nada y Dawn hace lo suyo de siempre. */
    formulario.addEventListener(
      'submit',
      async (ev) => {
        if (!activo()) return;
        ev.preventDefault();
        ev.stopImmediatePropagation();

        const contenedor = formulario.closest('product-form');
        const boton = formulario.querySelector('[type="submit"]');
        const giro = formulario.querySelector('.loading__spinner');
        if (boton) boton.setAttribute('aria-disabled', 'true');
        if (giro) giro.classList.remove('hidden');
        if (boton) boton.classList.add('loading');

        const datos = new FormData(formulario);
        const propiedades = {};
        datos.forEach((valor, clave) => {
          const m = clave.match(/^properties\[(.+)\]$/);
          if (m && String(valor).trim() !== '') propiedades[m[1]] = valor;
        });

        const etiqueta = bloque.dataset.etiqueta || 'Engraving message';
        const cuerpo = {
          items: [
            {
              id: Number(datos.get('id')),
              quantity: parseInt(datos.get('quantity'), 10) || 1,
              properties: propiedades,
            },
            {
              id: Number(campo.dataset.varianteGrabado),
              quantity: 1,
              properties: { [etiqueta]: campo.value.trim() },
            },
          ],
        };

        const cajon = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cajon && cajon.getSectionsToRender) {
          cuerpo.sections = cajon.getSectionsToRender().map((s) => s.id);
          cuerpo.sections_url = window.location.pathname;
        }

        try {
          const respuesta = await fetch(window.routes.cart_add_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(cuerpo),
          });
          const json = await respuesta.json();

          if (json.status) {
            /* Shopify contesta 200 con el error dentro. Se enseña donde Dawn
               enseña los suyos, para que no haya dos sitios donde mirar. */
            const hueco = formulario.querySelector('.product-form__error-message-wrapper');
            const texto = formulario.querySelector('.product-form__error-message');
            if (hueco && texto) {
              texto.textContent = json.description || json.message;
              hueco.removeAttribute('hidden');
            }
            return;
          }

          if (cajon && json.sections) {
            cajon.renderContents(json);
          } else {
            /* Sin secciones no hay cajón que pintar (pasa en la vista previa
               de un tema sin publicar, ver umya-vistaprevia.js). Se lleva a la
               página del carrito, que sí se pinta con el tema que se está
               mirando. */
            irAlCarrito();
          }
        } catch (e) {
          console.error('[umya-grabado]', e);
          irAlCarrito();
        } finally {
          if (boton) {
            boton.removeAttribute('aria-disabled');
            boton.classList.remove('loading');
          }
          if (giro) giro.classList.add('hidden');
          if (contenedor && contenedor.classList) contenedor.classList.remove('loading');
        }
      },
      true
    );

    repintar();
  });

  /* El enlace "How the engraving works" abre el desplegable de abajo y lleva
     la vista hasta él, igual que hace el de la guía de tallas. Mandar a
     alguien "a la explicación de abajo" sin llevarle es dejarle el trabajo. */
  document.addEventListener('click', (ev) => {
    const enlace = ev.target.closest('[data-umya-abre-grabado]');
    if (!enlace) return;
    const guia = document.querySelector('[data-umya-guia-grabado]');
    if (!guia) return;
    ev.preventDefault();
    guia.open = true;
    guia.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
